import React, {useContext} from "react";
import {Form, Radio, Row, Col} from "antd";
import {Title} from "./Common";
import MapPropsContext from "../MapPropsContext";
import {chunksForArray} from "../../../utils";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";
import Seperator from "./Seperator";


const OPTIONS_FRQ = [
  {frq_code: "100",  label: "100MHz대"},
  {frq_code: "200",  label: "200MHz대"},
  {frq_code: "400",  label: "400MHz대"},
];

// VHCLE PRTBL FIXING
const OPTIONS_USE = [
  {use_code: "PRTBL",   label: "휴대용"},
  {use_code: "FIXING",  label: "고정용"},
  {use_code: "VHCLE",   label: "차량용"},
];

// 지역정보 표시방법, value값은 as-is를 그대로 적용합니다.
const OPTIONS_DISPLAY = [
  {display_code: "01",  label: "주파수대역별"},
  {display_code: "02",  label: "용도별"},
];


function WidgetRadioStats() {
  const {widgetState, onChangeWidgetState} = useContext(MapPropsContext);
  const {display_code_stats} = widgetState;

  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="주파수 대역"
        fieldName={"frq_code_stats_list"}
        options={OPTIONS_FRQ.map(({ frq_code, label }) => ({
          value: frq_code,
          label,
        }))}
        colSpan={8} />

      <Seperator />

      <CheckboxGroupWithCheckAll
        title="용도"
        fieldName={"use_code_stats_list"}
        options={OPTIONS_USE.map(({ use_code, label }) => ({
          value: use_code,
          label,
        }))}
        colSpan={8} />

      <Seperator />

      <Title>지역정보 표시 방법 선택</Title>
      <Radio.Group name="display_code_stats"
                   value={display_code_stats}
                   style={{width: '100%'}}
                   onChange={onChangeWidgetState}>
        {chunksForArray(OPTIONS_DISPLAY, 2).map((chunk, index) =>
          <Row key={index}>
            {chunk.map(({ display_code, label }) =>
              <Col span={12} key={display_code}>
                <Radio value={display_code} key={display_code}>{label}</Radio>
              </Col>
            )}
          </Row>
        )}
      </Radio.Group>
    </Form.Item>
  );
}


export default WidgetRadioStats;
